import React, { useEffect } from 'react';
import './PagesStyle/Pages.css';


const Home = () => {
  
  useEffect(() => {
    const { hostname, port } = window.location;
  
    if (hostname === 'app.jobbox.one') {
      window.location.href = 'https://jobbox.one';
    } else if (hostname === 'localhost' && port === '3000') {
      window.location.href = 'http://localhost:3001';
    }
  }, []);

  return (
    <>
    
    </>
  );
};

export default Home;
